module.exports = __webpack_public_path__ + "bg.svg?42d2146c9924d0aa0e491ba75299cff9";